export const FETCH_USER_NOTIFICATION = {
  TRY_AGAIN_AFTER_SOMETIME: 'Please try again after some time...',
  PLEASE_RELOAD_TRY_AGAIN: 'Please reload the page and try again...',
  ERROR_ENCOUNTERED_WHILE_FETCHING_POLICY_DETAILS:
    'Encountered an error while fetching policy details.',
}

export const REGISTER = 'register'

export const CLIENT_IS = {
  CORPORATE: 'CORPORATE',
}

export const IS_ROUTES = {
  QCRREPORT: 'qrReport',
  CRHEALTHREPORT: 'crHealthReport',
  BUYPOLICY: 'buyPolicy',
  KHS: 'khs',
}

export const KEYCLOACK_EVENTS = {
  ON_AUTH_SUCCESS: 'onAuthSuccess',
  ON_TOKEN_EXPIRED: 'onTokenExpired',
  ON_AUTH_LOGOUT: 'onAuthLogout',
}
